import { render } from "./AwardsIcon.vue?vue&type=template&id=0afaf46c"
import script from "./AwardsIcon.vue?vue&type=script&lang=js"
export * from "./AwardsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__